import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-facility-animation',
    templateUrl: './facility-animation.component.html',
    styleUrls: ['./facility-animation.component.scss'],
    standalone: false
})
export class FacilityAnimationComponent {
  @Input() origin: string = '';
  @Input() target: string = '';
  @Input() action: 'SEND' | 'RETRIEVE' = 'SEND';
  @Input() originLocation: string = '';
  @Input() targetLocation: string = '';
  @Input() compact: boolean = false;
  @Input() showChangeTarget: boolean = false;
  @Output() changeTarget = new EventEmitter<void>();

  get isReverse(): boolean {
    return this.action === 'RETRIEVE';
  }
}
